<div class="empathy-viewer-progress-bar">
  <div class="empathy-viewer-progress-bar__fill" [style.width.%]="progress()" [ngClass]="[color()]"></div>
</div>
